/**
 * Describes all column's options.
 */
export interface PrimaryGeneratedColumnUUIDOptions {

    /**
     * Column name in the database.
     */
    name?: string;

    /**
     * Column comment. Not supported by all database types.
     */
    comment?: string;

}
